import React from 'react';

export const Clients_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>CLIENTS</span>,
  },
];

export const Clients_Text = [
  {
    textSize: '1rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    textMobile: '0.625rem',
    renderContent: () => (
      <span>
        Notice: All registered trademarks, trade names, and logos displayed on
        this website are the exclusive property of their respective owners.
        <br />
        Their use here is for reference and informational purposes only and does
        not imply any endorsement, affiliation, or sponsorship.
      </span>
    ),
  },
];
